<template>
  <v-container>
    <landing-create :content="content"></landing-create>
    <specimen-state-form
      :isLoading="isLoading"
      :onSubmit="onSubmit">
    </specimen-state-form>
  </v-container>
</template>

<script>
import LandingCreate from '../../../components/layouts/LandingCreate.vue';
import SpecimenStateForm from './SpecimenStateForm.vue';
import services from '../../../services';
import utilities from '../../../utilities';

const { ErrorMessageUtil } = utilities;
const { biobankRegistry } = services;
const { specimenStateService } = biobankRegistry;

export default {
  name: 'SpecimenStateCreate',
  components: {
    SpecimenStateForm,
    LandingCreate,
  },
  data: () => ({
    isLoading: false,
    content: {
      pageTitle: 'Create Preparation',
      enableBackButton: true,
    },
  }),
  methods: {
    async onSubmit(data) {
      this.isLoading = true;
      try {
        const { _id: id } = await specimenStateService.create({ specimenState: data });

        this.$snackbar.showOk({ text: 'Successfully created Preparation!' });

        this.$router.replace({ name: 'specimen-state.edit', params: { id } });
      } catch (e) {
        const error = e.response.data;
        this.$snackbar.showBad({
          text: ErrorMessageUtil.transform(error),
        });
      }
      this.isLoading = false;
    },
  },
};
</script>
